import React from 'react';
import './Accordion.scss';
import classNames from 'classnames';

export function AccordionDetails(props) {
  const {
    title = '',
    className = '',
    content = null,
    toggleFunction = () => {},
  } = props;

  return (
    <div className={classNames('accordion-details', className)}>
      <div className="accordion-details-title">
        <div className="f4">{title}</div>
        <div className="accordion-details-button" onClick={() => toggleFunction()}>Подробнее</div>
      </div>
      {content}
    </div>
  );
}
